'use es6';

import Actions from 'AdsUI/lib/Actions';
import MarketingContactsInfo from 'AdsUI/records/MarketingContactsInfo';
export default ((state = new MarketingContactsInfo(), action) => {
  switch (action.type) {
    case Actions.MARKETING_CONTACTS_INFO_FETCH_SUCCEEDED:
      {
        return new MarketingContactsInfo(action.payload);
      }

    default:
      {
        return state;
      }
  }
});